export default __webpack_public_path__ + "static/jasmine2-720e7a19680eec4d50e19c0f7cd43648.webp";